import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { GraphQLSubscriptionManager } from "./subscriptions.js";
const GraphQLContext = createContext(null);
const SubscriptionContext = createContext(null);
export const GraphQLProvider = (p) => {
    const subs = useMemo(() => new GraphQLSubscriptionManager(p.value), [p.value]);
    return (_jsx(GraphQLContext.Provider, { value: p.value, children: _jsx(SubscriptionContext.Provider, { value: subs, children: p.children }) }));
};
export const useSubscriptionClient = () => useContext(SubscriptionContext);
export const useGraphQLClient = () => {
    const client = useContext(GraphQLContext);
    if (!client)
        throw new Error("Missing hasura client provider");
    return client;
};
//# sourceMappingURL=context.js.map